import { Card } from 'primereact/card'
import { PropsWithChildren, ReactNode } from 'react'

import { Column } from './FlexContainer'
import ClassNameBuilder from '../../../tools/ClassNameBuilder'

interface ToggleCardProps extends PropsWithChildren {
    onClick: () => void
    selected?: boolean
}
export default function ToggleCard({ children, onClick, selected }: ToggleCardProps) {
    const classNames = new ClassNameBuilder().add('toggle-card').addIf('selected', selected)
    return (
        <Card className={classNames.toString()} onClick={onClick}>
            {children}
        </Card>
    )
}

interface ImageToggleCardProps extends ToggleCardProps {
    label: string
    src: string
}
export const ImageToggleCard = ({ children, label, src, ...props }: ImageToggleCardProps) => (
    <ToggleCard {...props}>
        <Column arrangement="center" alignment="center">
            <img src={src} />
            <div>{label}</div>
            {children}
        </Column>
    </ToggleCard>
)

interface IconToggleCardProps extends ToggleCardProps {
    label: string
    icon: ReactNode
}
export const IconToggleCard = ({ children, label, icon, ...props }: IconToggleCardProps) => (
    <ToggleCard {...props}>
        <Column arrangement="center" alignment="center">
            {icon}
            <div>{label}</div>
            {children}
        </Column>
    </ToggleCard>
)
